import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import { postCaseItem, postVideoItem, postSlideItem, postNewsItem, CMS_BASE_URL } from '../../redux/action';

import './post.css'; 
import '../common/common.css'; 

import csBanner from '../../images/csBanner.png';
import slideBanner from '../../images/slideBanner.png';
import videoBanner from '../../images/videoBanner.png';
import newsBanner from '../../images/newsBanner.png';
import videoBtn from '../../images/videoBtn.png';

class Post extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	title: "",
	    	banner: "",
	    	items: [],
	    };
    }


  componentDidMount() {
  	switch (this.props.postType) {
			case "case":
				postCaseItem({}).then(res => {
					this.setState({ 
						title: "Case Sharing",
						banner: csBanner,
						items: res.data 
					})
				}, this);
				
				break;

			case "video":
				postVideoItem({}).then(res => {
					this.setState({ 
						title: "Past Conference Video",
						banner: videoBanner,
						items: res.data 
					})
				}, this);
				break;

			case "slide":
				postSlideItem({}).then(res => {
					this.setState({ 
						title: "Slide Decks",
						banner: slideBanner,
						items: res.data 
					})
				}, this)
					
				break;

			case "news":
				postNewsItem({}).then(res => {
					this.setState({ 
						title: "News and Updates",
						banner: newsBanner,
						items: res.data 
					})
				}, this)
				break;

			default:
				break;
		}
  }  


	componentWillMount() {

		
		let token = window.localStorage.getItem("token");
		if (!token) {
			window.location.href = "/login";
		}
		
		// switch (this.props.postType) {
		// 	case "case":
		// 		this.setState({
		// 			title: "Case Sharing",
		// 			banner: csBanner,
		// 			items: [
		// 				{
		// 					id: 1,
		// 					thumb: "/images/news/news1.png",
		// 					date: "13 June 2022",
		// 					title: "Case Sharing 1"
		// 				},
		// 				{
		// 					id: 2,
		// 					thumb: "/images/news/news2.png",
		// 					date: "24 May 2022",
		// 					title: "Case Sharing 2"
		// 				},
		// 				{
		// 					id: 3,
		// 					thumb: "/images/news/news3.png",
		// 					date: "16 May 2022",
		// 					title: "Case Sharing 3"
		// 				},
		// 				{
		// 					id: 4,
		// 					thumb: "/images/news/news4.png",
		// 					date: "8 May 2022",
		// 					title: "Case Sharing 4"
		// 				},
		// 				{
		// 					id: 5,
		// 					thumb: "/images/news/news1.png",
		// 					date: "13 June 2022",
		// 					title: "Case Sharing 5"
		// 				},
		// 				{
		// 					id: 6,
		// 					thumb: "/images/news/news2.png",
		// 					date: "24 May 2022",
		// 					title: "Case Sharing 6"
		// 				},
		// 				{
		// 					id: 7,
		// 					thumb: "/images/news/news3.png",
		// 					date: "16 May 2022",
		// 					title: "Case Sharing 7"
		// 				},
		// 				{
		// 					id: 8,
		// 					thumb: "/images/news/news4.png",
		// 					date: "8 May 2022",
		// 					title: "Case Sharing 8"
		// 				},
		// 			]
		// 		})
		// 		break;

		// 	case "video":
		// 		this.setState({
		// 			title: "Past Conference Video",
		// 			banner: videoBanner,
		// 			items: [
		// 				{
		// 					id: 1,
		// 					thumb: "/images/news/news1.png",
		// 					date: "13 June 2022",
		// 					title: "Conference Video 1"
		// 				},
		// 				{
		// 					id: 2,
		// 					thumb: "/images/news/news2.png",
		// 					date: "24 May 2022",
		// 					title: "Conference Video 2"
		// 				},
		// 				{
		// 					id: 3,
		// 					thumb: "/images/news/news3.png",
		// 					date: "16 May 2022",
		// 					title: "Conference Video 3"
		// 				},
		// 				{
		// 					id: 4,
		// 					thumb: "/images/news/news4.png",
		// 					date: "8 May 2022",
		// 					title: "Conference Video 4"
		// 				},
		// 				{
		// 					id: 5,
		// 					thumb: "/images/news/news1.png",
		// 					date: "13 June 2022",
		// 					title: "Conference Video 5"
		// 				},
		// 				{
		// 					id: 6,
		// 					thumb: "/images/news/news2.png",
		// 					date: "24 May 2022",
		// 					title: "Conference Video 6"
		// 				},
		// 				{
		// 					id: 7,
		// 					thumb: "/images/news/news3.png",
		// 					date: "16 May 2022",
		// 					title: "Conference Video 7"
		// 				},
		// 				{
		// 					id: 8,
		// 					thumb: "/images/news/news4.png",
		// 					date: "8 May 2022",
		// 					title: "Conference Video 8"
		// 				},
		// 			]
		// 		})
		// 		break;

		// 	case "slide":
		// 		this.setState({
		// 			title: "Slide Decks",
		// 			banner: slideBanner,
		// 			items: [
		// 				{
		// 					id: 1,
		// 					thumb: "/images/news/news1.png",
		// 					date: "13 June 2022",
		// 					title: "Slide 1"
		// 				},
		// 				{
		// 					id: 2,
		// 					thumb: "/images/news/news2.png",
		// 					date: "24 May 2022",
		// 					title: "Slide 2"
		// 				},
		// 				{
		// 					id: 3,
		// 					thumb: "/images/news/news3.png",
		// 					date: "16 May 2022",
		// 					title: "Slide 3"
		// 				},
		// 				{
		// 					id: 4,
		// 					thumb: "/images/news/news4.png",
		// 					date: "8 May 2022",
		// 					title: "Slide 4"
		// 				},
		// 				{
		// 					id: 5,
		// 					thumb: "/images/news/news1.png",
		// 					date: "13 June 2022",
		// 					title: "Slide 5"
		// 				},
		// 				{
		// 					id: 6,
		// 					thumb: "/images/news/news2.png",
		// 					date: "24 May 2022",
		// 					title: "Slide 6"
		// 				},
		// 				{
		// 					id: 7,
		// 					thumb: "/images/news/news3.png",
		// 					date: "16 May 2022",
		// 					title: "Slide 7"
		// 				},
		// 				{
		// 					id: 8,
		// 					thumb: "/images/news/news4.png",
		// 					date: "8 May 2022",
		// 					title: "Slide 8"
		// 				},
		// 			]
		// 		})
		// 		break;

		// 	case "news":
		// 		this.setState({
		// 			title: "News and Updates",
		// 			banner: newsBanner,
		// 			items: [
		// 				{
		// 					id: 1,
		// 					thumb: "/images/news/news1.png",
		// 					date: "13 June 2022",
		// 					title: "News 1"
		// 				},
		// 				{
		// 					id: 2,
		// 					thumb: "/images/news/news2.png",
		// 					date: "24 May 2022",
		// 					title: "News 2"
		// 				},
		// 				{
		// 					id: 3,
		// 					thumb: "/images/news/news3.png",
		// 					date: "16 May 2022",
		// 					title: "News 3"
		// 				},
		// 				{
		// 					id: 4,
		// 					thumb: "/images/news/news4.png",
		// 					date: "8 May 2022",
		// 					title: "News 4"
		// 				},
		// 				{
		// 					id: 5,
		// 					thumb: "/images/news/news1.png",
		// 					date: "13 June 2022",
		// 					title: "News 5"
		// 				},
		// 				{
		// 					id: 6,
		// 					thumb: "/images/news/news2.png",
		// 					date: "24 May 2022",
		// 					title: "News 6"
		// 				},
		// 				{
		// 					id: 7,
		// 					thumb: "/images/news/news3.png",
		// 					date: "16 May 2022",
		// 					title: "News 7"
		// 				},
		// 				{
		// 					id: 8,
		// 					thumb: "/images/news/news4.png",
		// 					date: "8 May 2022",
		// 					title: "News 8"
		// 				},
		// 			]
		// 		})
		// 		break;

		// 	default:
		// 		break;
		// }
	}


	render() {

		return(
			<div className="geContainer">
				<Header urlKey={this.props.urlKey} />
				<div className="mainContainer">
					<img className="banner" src={this.state.banner} />
					<div className="sectionContainer">
						<div className="headline containerMaxWidth">
							<h2>{ this.state.title }</h2>
						</div>
						<div className="bodyContent containerMaxWidth postContainer">
							{
								(this.state.title != "" && this.state.items.length == 0) ? (<h2 style={{ color: "#ffaf00" }}>Coming Soon</h2>) : (this.state.items || []).map(item => {
									return (
										<a href={"/"+this.props.urlKey+"/"+item.id} className="postItem">
											<div>
												<div className="postThumbBox">
													<img className="postThumb" src={CMS_BASE_URL+"/storage/"+item.thumbnail} />
													{
														(this.props.postType == "video") ? <img className="videoBtn" src={videoBtn} /> : ""
													}
												</div>
												<p className="postDate">{item.date.split(' ')[0]}</p>
												<h3 className="postTitle">{item.title}</h3>
											</div>
										</a>
									)
								})
							}
						</div>
					</div>
				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(Post));